import Auth from "../models/Auth"
import {
    WS_HOST
} from "../config/misc"
export default {
    data() {
        return {
            pageModel: new Auth(),
            websocket: null,
            flag: true,
        }
    },
    mounted() {
        this.getAuth()
    },
    beforeDestroy() {
        this.flag = false
        this.websocket.close();
    },
    methods: {
        getAuth() {
            let _this = this
            this.pageModel.auth().then(res => {
                _this.initWebsocket(res.data)
            }).catch(e => {
                _this.$notify({
                    type: "error",
                    title: "失败",
                    message: "获取key失败"
                })
            })
        },
        initWebsocket(key) {
            let host = `${WS_HOST}${key}`
            this.websocket = new WebSocket(host)
            this.websocket.onopen = this.onOpenWs
            this.websocket.onerror = this.onErrorWs
            this.websocket.onmessage = this.onMessageWs
            this.websocket.onclose = this.onCloseWs
        },
        onOpenWs() {
            this.$notify({
                type: "success",
                title: "已连接消息服务器"
            })
        },
        onErrorWs(e) {
            console.log(e)
            this.$notify.error("与消息服务器连接失败")
        },
        onMessageWs(response) {
            let jsonData = JSON.parse(response.data)
            switch (jsonData.m) {
                case "message":
                    this.$notify({
                        type: "info",
                        title: "收到消息",
                        message: jsonData.d,
                        duration: 0
                    })
                    break;
                case "system":
                    if (typeof jsonData.d == "string") {
                        this.$notify({
                            type: "success",
                            title: "系统消息",
                            message: jsonData.d,
                            duration: 0
                        })
                    } else {
                        this.$store.commit("addItem", jsonData.d)
                    }
                    break;
                case "":
                    break;
                default:
                    break
            }
        },
        onCloseWs() {
            if (this.flag) {
                let _this = this;
                setTimeout(function () {
                    _this.getAuth()
                }, 10000)
            }
        }
    },
}